import React, { useEffect } from 'react';
import './../styles/service-page.css';

const ResidentialCleaningPage = () => {
   useEffect(() => {
     // Scroll to top when component mounts
     window.scrollTo(0, 0);
 
     // Parallax effect for hero background
     // const handleScroll = () => {
     //   const scrolled = window.scrollY;
     //   const heroBackground = document.querySelector('.hero-section');
     //   if (heroBackground && scrolled < 600) {
     //     const yPos = -(scrolled * 0.5);
     //     heroBackground.style.backgroundPositionY = `${yPos}px`;
     //   }
     // };
 
     // window.addEventListener('scroll', handleScroll);
 
     // Add scroll animations matching homepage
     const observeElements = () => {
       const elements = document.querySelectorAll('.slide-in-up, .slide-in-left, .slide-in-right');
       
       const observer = new IntersectionObserver((entries) => {
         entries.forEach(entry => {
           if (entry.isIntersecting) {
             entry.target.classList.add('visible');
           }
         });
       }, {
         threshold: 0.1,
         rootMargin: '0px 0px -50px 0px'
       });
 
       elements.forEach(element => {
         observer.observe(element);
       });
 
       // Stagger animations for service cards
       const cards = document.querySelectorAll('.service-card');
       cards.forEach((card, index) => {
         card.style.transitionDelay = `${index * 0.1}s`;
       });
 
       // Stagger process steps
       const steps = document.querySelectorAll('.process-step');
       steps.forEach((step, index) => {
         step.style.transitionDelay = `${index * 0.15}s`;
       });
     };
 
     setTimeout(observeElements, 100);
 
     // Cleanup
     // return () => {
     //   window.removeEventListener('scroll', handleScroll);
     // };
   }, []);
 
   return (
     <div className="service-page">
       {/* Hero Section with Background Image */}
       <section 
         className="hero-section"
         style={{
           backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url('https://media.istockphoto.com/id/1316473356/photo/an-employee-pulls-a-trolley-for-cleaning-offices-woman-cleaner-is-engaged-in-work.jpg?s=612x612&w=0&k=20&c=6QWgeQ8HQU4TvT4lu9l2hBLiKUVYLcF_6-deEMn-vb8=')`,
           backgroundRepeat: "no-repeat",
           backgroundSize: "cover",
           backgroundPosition: "center",
         }}
       >
         <div className="hero-overlay"></div>
         <div className="container">
           <div className="header-content slide-in-up">
             <h1>Residential & Commercial Cleaning</h1>
             <p className="header-subtitle">
               Professional cleaning services across Hampshire. We ensure your home and workplace stay spotless, hygienic, and comfortable — from regular domestic cleaning to deep sanitation services.
             </p>
           </div>
         </div>
       </section>
 
       {/* Service Overview */}
 <section className="service-overview">
   <div className="container">
     <div className="overview-grid">
       <div className="overview-content slide-in-left">
         <h2>Why Choose The Clean Knight?</h2>
         <p>
           A clean environment isn't just about appearances—it's about health, comfort, and 
           peace of mind. Whether it's your home or workplace, accumulated dirt, allergens, 
           and bacteria can affect air quality and overall wellbeing. Regular professional 
           cleaning creates a healthier space for you, your family, and your employees.
         </p>
         <p>
           Our professional cleaning team uses industry-leading techniques and eco-friendly 
           products to deliver exceptional results. From routine house cleaning to deep 
           sanitation services, we tailor our approach to your specific needs. With attention 
           to detail and reliable service, we ensure every corner meets the highest standards 
           of cleanliness.
         </p>
         <div className="key-benefits">
           <div className="benefit-item">
             <span className="benefit-icon">✓</span>
             <span>Healthier indoor environment</span>
           </div>
           <div className="benefit-item">
             <span className="benefit-icon">✓</span>
             <span>Eco-friendly cleaning products</span>
           </div>
           <div className="benefit-item">
             <span className="benefit-icon">✓</span>
             <span>Fully insured & trained team</span>
           </div>
           <div className="benefit-item">
             <span className="benefit-icon">✓</span>
             <span>Flexible scheduling available</span>
           </div>
         </div>
       </div>
       <div className="overview-image slide-in-right">
         <img src="https://media.istockphoto.com/id/2098028629/photo/janitor-use-floor-scrubber-machine-on-the-floor-hallway-office-building-or-walkway-after.jpg?s=612x612&w=0&k=20&c=nGqDn5fxE4WwZmg65RtZ8o_lWv1fb8xcLYPalsfMy0M=" alt="Professional cleaning service" />
       </div>
     </div>
   </div>
 </section>
 
       {/* What's Included */}
       <section className="whats-included">
         <div className="container">
           <h2 className="section-title slide-in-up">Our Comprehensive Cleaning Services</h2>
           
           <div className="services-grid">
             <div className="service-card slide-in-up">
               <div className="service-icon">
                 <span>🏠</span>
               </div>
               <h3>House & Deep Cleaning</h3>
               <p>
                 Thorough cleaning of all living spaces including dusting, vacuuming, mopping, 
                 and sanitizing. Deep cleaning reaches those hard-to-access areas for a truly spotless home.
               </p>
             </div>
 
             <div className="service-card slide-in-up">
               <div className="service-icon">
                 <span>🪟</span>
               </div>
               <h3>Window & Glass Cleaning</h3>
               <p>
                 Streak-free window cleaning for a crystal-clear view. We clean both interior 
                 and exterior glass surfaces, frames, and sills to perfection.
               </p>
             </div>
 
             <div className="service-card slide-in-up">
               <div className="service-icon">
                 <span>🛋️</span>
               </div>
               <h3>Carpet & Upholstery Cleaning</h3>
               <p>
                 Professional deep cleaning to remove stains, odors, and allergens from carpets 
                 and furniture. Revitalizes fabrics and extends their lifespan.
               </p>
             </div>
 
             <div className="service-card slide-in-up">
               <div className="service-icon">
                 <span>🚿</span>
               </div>
               <h3>Bathroom & Kitchen Sanitisation</h3>
               <p>
                 Complete sanitisation of high-use areas. We eliminate bacteria, mold, and grime 
                 from surfaces, fixtures, and appliances for a hygienic environment.
               </p>
             </div>
 
             <div className="service-card slide-in-up">
               <div className="service-icon">
                 <span>🏢</span>
               </div>
               <h3>Office & Retail Space Cleaning</h3>
               <p>
                 Commercial cleaning tailored to your business needs. Create a professional, 
                 welcoming environment for employees and customers with our reliable service.
               </p>
             </div>
 
             <div className="service-card slide-in-up">
               <div className="service-icon">
                 <span>🔑</span>
               </div>
               <h3>End of Tenancy Cleaning</h3>
               <p>
                 Comprehensive move-out cleaning to ensure properties meet landlord standards. 
                 Perfect for securing your deposit or preparing a property for new tenants.
               </p>
             </div>
           </div>
         </div>
       </section>
 
       {/* Additional Services Overview */}
 <section className="service-overview">
   <div className="container">
     <div className="overview-grid">
       <div className="overview-content slide-in-left">
         <h2>Specialized Cleaning Solutions</h2>
         <p>
           Beyond our standard services, we offer specialized cleaning solutions designed 
           for unique situations. Whether you're moving out, preparing for guests, or dealing 
           with stubborn stains, our expert team has the knowledge and equipment to handle 
           any challenge. We adapt our methods to suit different surfaces and materials.
         </p>
         <p>
           Our commitment to quality means we never cut corners. Every service includes 
           a thorough inspection, proper preparation, and detailed attention to problem areas. 
           We use professional-grade equipment and proven techniques to deliver results that 
           exceed expectations, every single time.
         </p>
         <div className="key-benefits">
           <div className="benefit-item">
             <span className="benefit-icon">✓</span>
             <span>Same-day service available</span>
           </div>
           <div className="benefit-item">
             <span className="benefit-icon">✓</span>
             <span>Pet & child-safe products</span>
           </div>
           <div className="benefit-item">
             <span className="benefit-icon">✓</span>
             <span>Satisfaction guarantee</span>
           </div>
           <div className="benefit-item">
             <span className="benefit-icon">✓</span>
             <span>Professional-grade equipment</span>
           </div>
           <div className="benefit-item">
             <span className="benefit-icon">✓</span>
             <span>Regular maintenance plans available</span>
           </div>
           <div className="benefit-item">
             <span className="benefit-icon">✓</span>
             <span>Competitive pricing with no hidden fees</span>
           </div>
         </div>
       </div>
       <div className="overview-image slide-in-right">
         <img src="https://media.istockphoto.com/id/1726516763/photo/close-up-view-of-wet-floor-caution-sign-and-bucket-on-slippery-tile-floor-in-open-plan-office.jpg?s=612x612&w=0&k=20&c=g_rB-lB_34aAXjBFEBCdWu4uhhubMOFaat5sN2Z4S7g=" alt="Specialized cleaning services" />
       </div>
     </div>
   </div>
 </section>
 
       {/* Our Process */}
       <section className="our-process">
         <div className="container">
           <h2 className="section-title slide-in-up">Our Simple 4-Step Process</h2>
           
           <div className="process-steps">
             <div className="process-step slide-in-left">
               <div className="step-number">1</div>
               <div className="step-content">
                 <h3>Free Quote & Consultation</h3>
                 <p>
                   Contact us for a free, no-obligation quote. We'll discuss your cleaning needs, 
                   assess your space, and provide you with a detailed estimate tailored to your requirements.
                 </p>
               </div>
             </div>
 
             <div className="process-step slide-in-right">
               <div className="step-number">2</div>
               <div className="step-content">
                 <h3>Schedule & Preparation</h3>
                 <p>
                   Choose a convenient time that works for you. We'll arrive promptly with all 
                   necessary equipment and eco-friendly cleaning products ready to transform your space.
                 </p>
               </div>
             </div>
 
             <div className="process-step slide-in-left">
               <div className="step-number">3</div>
               <div className="step-content">
                 <h3>Professional Cleaning</h3>
                 <p>
                   Our trained team systematically cleans every area using proven techniques and 
                   professional equipment, paying special attention to high-traffic and problem areas.
                 </p>
               </div>
             </div>
 
             <div className="process-step slide-in-right">
               <div className="step-number">4</div>
               <div className="step-content">
                 <h3>Final Walkthrough</h3>
                 <p>
                   We conduct a thorough quality check with you to ensure complete satisfaction. 
                   If anything doesn't meet your standards, we'll address it immediately at no extra cost.
                 </p>
               </div>
             </div>
           </div>
         </div>
       </section>
 
       {/* Call to Action */}
       <section className="cta-section">
         <div className="container">
           <div className="cta-content slide-in-up">
             <h2>Ready for a Spotlessly Clean Space?</h2>
             <p>
               Get your free quote today and discover how The Clean Knight can transform your 
               home or workplace. Most quotes provided within 24 hours with no obligation to proceed.
             </p>
             <div className="cta-buttons">
               <a href="/#contact" className="btn btn-primary">Get Free Quote</a>
             </div>
             <div className="cta-assurance">
               <span>✓ Fully insured</span>
               <span>✓ Satisfaction guaranteed</span>
               <span>✓ Free quotes</span>
               <span>✓ No hidden fees</span>
             </div>
           </div>
         </div>
       </section>
     </div>
   );
 };

export default ResidentialCleaningPage;